const {WarehouseLevel} = require("./WarehouseLevel");

class Pagination {
    /**
     * @type {number}
     */
    page;

    /**
     * @type {number}
     */
    elementsPerPage;

    /**
     * @type {number}
     */
    totalPages;

    /**
     * @type {number}
     */
    totalEntries;

    constructor(page, elementsPerPage) {
        this.page = page;
        this.elementsPerPage = elementsPerPage;
    }

    get offset() {
        return this.page * this.elementsPerPage
    }
}

module.exports.Pagination = Pagination;

class PaginationResponse {
    /**
     * @type {ProductSearchResult[]}
     */
    data;

    /**
     * @type {Pagination}
     */
    pagination;


    constructor(products, pagination) {
        this.data = products.map(dto => new ProductSearchResult(dto));
        this.pagination = pagination;
    }
}

module.exports.PaginationResponse = PaginationResponse;

class ProductSearchResult {
    /**
     * @type {Product}
     */
    product;

    /**
     * @type {WarehouseLevel[]}
     */
    levels;

    /**
     * @param dto {{
     *          product: {
     *              id: {value: string},
     *              productNumberManufacturer: string,
     *              manufacturerName: string,
     *              productNumberCustomer: string,
     *              unit: ProductUnit,
     *              description: ProductDescription,
     *              suppliers: ProductSupplier[]
     *          },
     *          levels: WarehouseLevel[]
     *      }}
     */
    constructor(dto) {
        this.product = new Product(dto.product);
        this.levels = dto.levels.map(l => new WarehouseLevel(l));
    }
}

module.exports.ProductSearchResult = ProductSearchResult;

class Product {
    /**
     * @type {string}
     */
    id;

    /**
     * @type {string}
     */
    productNumberManufacturer;

    /**
     * @type {string}
     */
    manufacturerName;

    /**
     * @type {string}
     */
    productNumberCustomer;

    /**
     * @type {ProductUnit}
     */
    unit;

    /**
     * @type {ProductDescription}
     */
    description;

    /**
     * @type {ProductSupplier[]}
     */
    suppliers;


    /**
     * @param dto {{
     *     id: {value: string},
     *     productNumberManufacturer: string,
     *     manufacturerName: string,
     *     productNumberCustomer: string,
     *     unit: ProductUnit,
     *     description: ProductDescription,
     *     suppliers: ProductSupplier[]
     * }}
     */
    constructor(dto) {
        this.id = dto.id.value;
        this.productNumberManufacturer = dto.productNumberManufacturer;
        this.manufacturerName = dto.manufacturerName;
        this.productNumberCustomer = dto.productNumberCustomer;
        this.unit = new ProductUnit(dto.unit.orderUnit, dto.unit.contentUnit, dto.unit.contentUnitsPerOrderUnit);
        this.description = new ProductDescription(dto.description.name, dto.description.text);
        this.suppliers = dto.suppliers.map(s => new ProductSupplier(s.supplierCompanyId, s.supplierName, s.supplierArtNo));
    }
}

module.exports.Product = Product;

class ProductSupplier {

    /**
     * @type {string}
     */
    supplierCompanyId;

    /**
     * @type {string}
     */
    supplierName;

    /**
     * @type {string}
     */
    supplierArtNo;


    /**
     *
     * @param supplierCompanyId {string}
     * @param supplierName {string}
     * @param supplierArtNo {string}
     */
    constructor(supplierCompanyId, supplierName, supplierArtNo) {
        this.supplierCompanyId = supplierCompanyId;
        this.supplierName = supplierName;
        this.supplierArtNo = supplierArtNo;
    }
}

module.exports.ProductSupplier = ProductSupplier;

class ProductUnit {
    /**
     * @type {string}
     */
    orderUnit;

    /**
     * @type {string}
     */
    contentUnit;

    /**
     * @type {number}
     */
    contentUnitsPerOrderUnit;

    /**
     * @param orderUnit {string}
     * @param contentUnit {string}
     * @param contentUnitsPerOrderUnit {number}
     */
    constructor(orderUnit, contentUnit, contentUnitsPerOrderUnit) {
        this.orderUnit = orderUnit;
        this.contentUnit = contentUnit;
        this.contentUnitsPerOrderUnit = contentUnitsPerOrderUnit;
    }
}

module.exports.ProductUnit = ProductUnit;

class ProductDescription {
    /**
     * @type {string}
     */
    name;

    /**
     * @type {string}
     */
    text;


    /**
     * @param name {string}
     * @param text {string}
     */
    constructor(name, text) {
        this.name = name;
        this.text = text;
    }
}

module.exports.ProductDescription = ProductDescription;